import { render } from "./detail-evaluasi-pasca-pelatihan.vue?vue&type=template&id=51491ad0"
import script from "./detail-evaluasi-pasca-pelatihan.vue?vue&type=script&lang=js"
export * from "./detail-evaluasi-pasca-pelatihan.vue?vue&type=script&lang=js"

import "./detail-evaluasi-pasca-pelatihan.vue?vue&type=style&index=0&id=51491ad0&lang=css"

import exportComponent from "/home/alfahuma/manual_build/digita-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__